import { auth } from '@monorepo/utils/firebase'
import { log } from '@monorepo/utils/utils'

/**
 * Store the current user's ID if they are anonymous
 * This should be called when an anonymous user signs in
 * The ID will be used later for migration if the user creates a permanent account
 */
export const storeAnonymousUserId = (): void => {
  const currentUser = auth().currentUser

  if (currentUser && currentUser.isAnonymous) {
    try {
      // Use localStorage if available (browser), otherwise silently fail
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('anonymousUserId', currentUser.uid)
        log(`Anonymous user ID stored: ${currentUser.uid}`)
      }
    } catch (error) {
      console.error('Error storing anonymous user ID:', error)
    }
  }
}

/**
 * Get the stored anonymous user ID if available
 * @returns The stored anonymous user ID or null if none exists
 */
export const getStoredAnonymousUserId = (): string | null => {
  try {
    // Use localStorage if available (browser), otherwise return null
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem('anonymousUserId')
    }
  } catch (error) {
    console.error('Error retrieving anonymous user ID:', error)
  }
  return null
}

/**
 * Clear the stored anonymous user ID
 */
export const clearStoredAnonymousUserId = (): void => {
  try {
    // Use localStorage if available (browser), otherwise silently fail
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('anonymousUserId')
      log('Anonymous user ID cleared')
    }
  } catch (error) {
    console.error('Error clearing anonymous user ID:', error)
  }
}
